import { Clue } from "./clue";
import { Row, RowState } from "./Row";
import { maxGuesses } from "./util";
import { endStateMessage, targetString } from "./Game";


export function Endstate() {

  const wordURLsearch = 'https://www.folger.edu/search/?q='+targetString+'&area=works';

  return (
    <div className="App-endstate">
          <h1>{endStateMessage}</h1>
      <p>
              Read all the ways Shakespeare used "<strong>{targetString}</strong>" at <a href={wordURLsearch} target="_blank">The Folger Shakespeare</a>
          </p>
        <img id="CTAimage" src="cta.jpg" width="450"/>
      </div>

  );
}
